import { Image } from 'expo-image';
import React from 'react';
import { View } from 'react-native';

export interface AppointmentCalendarIconProps {
  size?: number;
}

/**
 * Animated calendar mark for listing upcoming-appointment card.
 * Source: assets/images/gif/appointment-calendar.gif
 */
export function AppointmentCalendarIcon({
  size = 40,
}: Readonly<AppointmentCalendarIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Image
        source={require('@assets/images/gif/appointment-calendar.gif')}
        style={{ width: size, height: size }}
        contentFit="contain"
      />
    </View>
  );
}

export default AppointmentCalendarIcon;
